<app-container class="flex justify-center container" ngClass.xs="xs" [maxWidth]="handsetService.isXs ? '100%' : '516px'"
               [noPadding]="handsetService.isXs">
  <mat-card class="card" ngClass.xs="xs">
    <div class="flex flex-col items-center mb-50" ngClass.xs="flex-col-reverse">
      <div class="flex flex-col items-center">
        <h1 class="header">Trwa odczytywanie...</h1>
        <p class="font-small" style="margin-top: 0; margin-bottom: 2rem">
          Odczytywanie przekazanego dokumentu zajmie nam chwilę. Poczekaj lub dokończymy w tle i poinformujemy Cię gdy wydatek będzie odczytany..
        </p>
      </div>

      <div class="spinner" ngClass.xs="xs">
        <mat-progress-spinner [value]="progress.loaderValue$ | async" diameter="200" strokeWidth="2"> </mat-progress-spinner>
        <div class="file-circle" *ngIf="urlSafe">
          <iframe [src]="urlSafe" title="File pdf" width="300px" height="400px"> </iframe>
        </div>
        <div class="loader-value">{{ progress.loaderValue$ | async }}%</div>
      </div>
    </div>


    <div class="flex flex-col">
      <app-new-loader-button
        class="big-button button-250 self-center"
        color="accent"
        [customType]="LoaderButtonType.RAISED"
        cdkFocusInitial
        buttonType="submit"
        (buttonClick)="onGoToAllLiabilities()">
        Dokończ w tle
      </app-new-loader-button>
    </div>

  </mat-card>
</app-container>
